import React, { memo, forwardRef, useImperativeHandle } from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Space, Card, Text, LoadingContainer } from '@redlink/components/atoms';
import { FormActions, GoogleLoginButton } from '@redlink/components/muscles';
import { useMutation, continueWithGoogleQuery } from '@redlink/services';
import AsyncStorage from '@react-native-community/async-storage';
import { useValues } from '@redlink/assets/values';
import { useNavigation, StackActions } from '@react-navigation/native';
import { clearCache } from '@redlink/services/cache';
import { AuthPageContainerRootContainer } from './authPageContainerRootContainer';

export const AuthPageContainerTemplate = memo(
  forwardRef(({ children, actions, title, isBusy }, ref) => {
    const { styles } = useStyle();
    const { routes } = useValues();
    const { dispatch } = useNavigation();

    const [
      continueWithGoogle,
      { loading: continueWithGoogleIsBusy },
    ] = useMutation(continueWithGoogleQuery, {
      done: async ({ ContinueWithGoogle }) =>
        await ref.current.onAuthSuccess(ContinueWithGoogle),
    });

    const onGoogleSuccess = ({ tokenId }) => {
      continueWithGoogle({ googleToken: tokenId });
    };

    const onGoogleFailure = (e) => {
      console.log('LEE', e);
    };

    useImperativeHandle(ref, () => ({
      onAuthSuccess: async ({ token }) => {
        await clearCache();
        await AsyncStorage.setItem('@token', token);
        dispatch(StackActions.replace(routes.dashboard.key));
      },
    }));

    return (
      <AuthPageContainerRootContainer>
        <Card style={styles.formContainer}>
          <LoadingContainer isBusy={isBusy || continueWithGoogleIsBusy}>
            <Text style={styles.titleText}>{title}</Text>
            <View style={styles.formContentContainer}>
              <ScrollView
                showsVerticalScrollIndicator={false}
                contentContainerStyle={styles.formScrollContentContainer}
              >
                <GoogleLoginButton
                  onFailure={onGoogleFailure}
                  onSuccess={onGoogleSuccess}
                />
                <Space size={80} />
                {children}
              </ScrollView>
            </View>
            {actions && <FormActions {...{ actions }} />}
          </LoadingContainer>
        </Card>
      </AuthPageContainerRootContainer>
    );
  })
);

const useStyle = createUseStyle(({ colors, size }) => ({
  formContainer: {
    flex: 1,
    paddingVertical: 16,
    paddingHorizontal: 24,
  },
  formContentContainer: {
    flex: 1,
  },
  titleText: {
    fontSize: 18,
    color: colors.gray23,
  },
  formScrollContentContainer: {
    paddingVertical: 30,
  },
  image: {
    ...StyleSheet.absoluteFillObject,
    margin: 50,
  },
}));
